import React from 'react'
import Image from '../../../UI/UIComponent/Image'
import Button from '../../../UI/UIComponent/Button'
import './hospitalDetailCard.scss'

export default function HospitalDetailCard(props) {
  const heading = props.Heading;
  const subHead = props.subHead;
  const image = props.imageVal;
  const enquireNwBtn = props.handlenqrNwBtnClick;
  const hospitalAdmissionIcon = 'hospital-admission-icon'
  const IcuIcon = 'surgery-consultation-icon'
  const doctorConsultation = 'Doctor-consultation-icon'
  const imgPath = require.context('../../../assets/Images/Svg', true);
  return (
    <div className="card border-0  hospitalDetail-card">
      <div className="row g-3 align-items-start">
        <div className="col-12 col-sm-3 text-center text-sm-start">
          <Image
            imageSrc={image}
            imageAltText={`RHS Associated Hospitals ${heading}`}
            imageClass={'w-100'}
          ></Image>
        </div>

        <div className="col-12 col-sm-9">
          <h5 className="mb-1 hospital-name">{heading}</h5>
          <p className="text-muted small mb-2 hospital-address">{subHead}</p>

          <span className="badge bg-danger rounded-pill mb-3">4.8</span>

          <div className="d-flex flex-wrap gap-3 text-muted small mb-3 hospital-facilities">
            <div className="d-flex align-items-center gap-1 facility-name">
              <img src={imgPath(`./${hospitalAdmissionIcon}.svg`)} alt=""></img>
              Emergency Admission
            </div>
            <span className="d-flex align-items-center gap-1 facility-name">
              <img src={imgPath(`./${IcuIcon}.svg`)} alt=""></img>
              ICU & all types of Surgery
            </span>
            <span className="d-flex align-items-center gap-1 facility-name">
              <img src={imgPath(`./${doctorConsultation}.svg`)} alt=""></img>
              Doctor Consultation
            </span>
          </div>
        </div>
      </div>
      <div className="row g-3 align-items-start">
        {/* <p className="about mb-0">About</p>
        <ul className="mb-3 small text-muted ps-4 hospital-description">
          <li>
            Fortis Hospital is a leading integrated healthcare delivery service
            provider in India.
          </li>
          <li>It is NABH accredited and governed by IBMS.</li>
          <li>It is one of the best heart hospitals in Kolkata.</li>
        </ul> */}
        <div className="d-flex flex-wrap gap-2 btn-group">
          <Button primaryButton={false}>Learn More</Button>
          <Button primaryButton={true} buttonClickHandler={enquireNwBtn}>Enquire Now</Button>
        </div>
      </div>
    </div>
  )
}
